import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import {
  Table,
  TableRow,
  TableBody,
  TableHead,
  TableCell,
  withStyles,
  TableSortLabel,
} from '@material-ui/core'

import Checkbox from './Checkbox'
import Automation from './Automation'


const styles = theme => ({
  root: {
    marginTop: theme.spacing(2),
  },
  disableMargin: {
    marginTop: 0,
  },
  marginCheckbox: {
    marginLeft: 0,
  },
  headCell: {
    fontWeight: "bold",
    backgroundColor: "whitesmoke",
  }
})


class TableAutomation extends PureComponent {
  /* LIFECYCLE */


  /* METHODS */

  /**
   * On click on an item
   * @param {*} item - The item selected
   */
  handleClick = (item) => (e) => {
    const { onClick } = this.props

    if (onClick) {
      onClick(item, e)
    }
  }


  /* RENDER */

  /**
   * @render
   * @returns {JSX}
   */
  render() {
    const {
      row,
      head,
      items,
      classes,
      onClick,
      selected,
      isLoading,
      className,
      selectable,
      onPageChange,
      onToggleSelectAll,
      ...props
    } = this.props

    return (
      <Automation
        {...props}
        row={row}
        head={head}
        items={items}
        isLoading={isLoading}
        onPageChange={onPageChange}
      >
        <Table>
          <TableHead>
            <TableRow>
              {selectable && (
                <TableCell className={classes.headCell} padding="checkbox">
                  <Checkbox
                    onChange={onToggleSelectAll}
                    className={classes.marginCheckbox}
                    checked={selected.length > 0 && selected.length === items.length}
                    indeterminate={selected.length > 0 && selected.length < items.length}
                  />
                </TableCell>
              )}

              {head.map((cell) => {
                return (
                  <TableCell className={classes.headCell} key={cell}>
                    {cell && typeof cell === 'object' && (
                      <TableSortLabel
                        active={cell.active}
                        onClick={cell.onClick}
                        direction={cell.active ? cell.direction : 'asc'}
                      >
                        {cell.label}
                      </TableSortLabel>
                    )}

                    {typeof cell === 'string' && cell}
                  </TableCell>
                )
              })}
            </TableRow>
          </TableHead>

          <TableBody>
            {items.map(item => {
              const values = row(item)

              return (
                <TableRow
                  key={item.id}
                  hover={!!onClick}
                  onClick={this.handleClick(item)}
                >
                  {selectable && (
                    <TableCell padding="checkbox">
                      <Checkbox className={classes.marginCheckbox} checked={selected.includes(item.id)} />
                    </TableCell>
                  )}
                  {values.map((value, idx) => (
                    <TableCell key={`${item.id}-${head[idx]}`}>
                      {typeof value === 'object' ? value.display : value}
                    </TableCell>
                  ))}
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </Automation>
    )
  }
}


TableAutomation.defaultProps = {
  row: [],
  head: [],
  items: [],
  selected: [],
}


TableAutomation.propTypes = {
  onClick: PropTypes.func,
  hasMore: PropTypes.bool,
  isLoading: PropTypes.bool,
  csvTitle: PropTypes.string,
  selectable: PropTypes.bool,
  hasPrevious: PropTypes.bool,
  className: PropTypes.string,
  onPageChange: PropTypes.func,
  disableMargin: PropTypes.bool,
  onToggleSelectAll: PropTypes.func,
  request: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  items: PropTypes.arrayOf(PropTypes.object),
  selected: PropTypes.arrayOf(PropTypes.string),
  row: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object])),
  head: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object])),
}


export default withStyles(styles)(TableAutomation)
